import { AssetSheetDerivedRowStatus } from '@atlas/types'
import { Badge, type BadgeProps } from '@atlas/ui-primitives'

const LOOK: Record<AssetSheetDerivedRowStatus, { label: string; variant: BadgeProps['variant'] }> = {
	[AssetSheetDerivedRowStatus.DONE]: { label: 'Done', variant: 'success' },
	[AssetSheetDerivedRowStatus.IN_PROGRESS]: { label: 'In progress', variant: 'warning' },
	[AssetSheetDerivedRowStatus.HAS_FAILURES]: { label: 'Has failures', variant: 'danger' },
	[AssetSheetDerivedRowStatus.BLOCKED]: { label: 'Blocked', variant: 'danger' },
	[AssetSheetDerivedRowStatus.REMOVED]: { label: 'Removed', variant: 'muted' },
}

/** A row status's display name, for filters and messages. */
export const rowStatusLabel = (status: AssetSheetDerivedRowStatus) => LOOK[status].label

/** Where a sheet row stands, as the rows endpoint derives it. */
export function RowStatusBadge({ status }: { status: AssetSheetDerivedRowStatus }) {
	const { label, variant } = LOOK[status]
	return (
		<Badge variant={variant} size="sm">
			{label}
		</Badge>
	)
}
